import { action } from '@ember/object';
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import ImportModel from 'cio/models/import';

export default class ValidatingController extends Controller {
  @service router!: RouterService;

  declare model: ImportModel;

  @action
  transitionToReview() {
    return this.router.transitionTo('imports.import.setup.review', this.model.id);
  }
}
